__turbopack_context__.v({
  "content": "LegalSection-module__2c7VuG__content",
  "section": "LegalSection-module__2c7VuG__section",
  "title": "LegalSection-module__2c7VuG__title",
});
